(ns dashboard.views.browser-extension.new-questionnaire.view
  (:require
   [re-frame.core :as rf]
   [reitit.frontend.easy :as rfe]
   [dashboard.services.http-config :as http-config]
   [dashboard.views.browser-extension.questionnaire.config :as questionnaire-config]
   [dashboard.notifications :as notifications]
   [dashboard.services.questionnaire-list :as questionnaire-list]))

(rf/reg-sub
 ::new-questionnaire-form
 (fn [db [_]]
   (get db :new-questionnaire-form)))

(rf/reg-event-db
 ::update-new-questionnaire-form
 (fn [db [_ updates]]
   (update-in db [:new-questionnaire-form :values] merge updates)))

(rf/reg-event-fx
 ::create-questionnaire
 (fn [{:keys [db]} [_]]
   (let [questionnaire (-> db :new-questionnaire-form :values)]
     {:db (assoc-in db [:new-questionnaire-form :loading] true)
      :http-xhrio {:method          :post
                   :uri             "/api/questionnaires/"
                   :timeout         http-config/timeout
                   :format          http-config/transit-request-format
                   :response-format http-config/transit-response-format
                   :params          questionnaire
                   :on-success      [::create-questionnaire-successful]
                   :on-failure      [::create-questionnaire-failed]}})))

(rf/reg-event-fx
 ::create-questionnaire-successful
 (fn [{:keys [db]} [_ {:keys [id] :as new-questionnaire}]]
   (rfe/replace-state questionnaire-config/view-id {:id (str id)})
   {:db (-> db
            (assoc-in [:new-questionnaire-form :loading] false)
            (assoc-in [:new-questionnaire-form :values] {})
            (questionnaire-list/add-questionnaire new-questionnaire))
    :dispatch [::notifications/add {:message "Your new questionnaire is ready for questions"}]}))

(rf/reg-event-fx
 ::create-questionnaire-failed
 (fn [{:keys [db]} [_]]
   {:db (assoc-in db [:new-questionnaire-form :loading] false)
    :dispatch [::notifications/add {:message "Could not create questionnaire"}]}))

(defn new-questionnaire-page []
  (let [{:keys [values loading]} @(rf/subscribe [::new-questionnaire-form])
        create-disabled? (or (-> values :name nil?)
                             (-> values :url nil?)
                             loading)]
    [:div.section.pt-6
     [:p.title "Create a new questionnaire"]

     [:form {:on-submit (fn [e]
                          (.preventDefault e)
                          (rf/dispatch [::create-questionnaire]))}
      [:div.field
       [:label.label "Questionnaire name"]
       [:div.control
        [:input.input {:type "text"
                       :placeholder "Enter questionnaire name"
                       :value (:name values)
                       :on-change #(rf/dispatch [::update-new-questionnaire-form {:name (.. % -target -value)}])}]]]
      [:div.field
       [:label.label "Questionnaire URL"]
       [:div.control
        [:input.input {:type "text"
                       :placeholder "Enter questionnaire URL"
                       :value (:url values)
                       :on-change #(rf/dispatch [::update-new-questionnaire-form {:url (.. % -target -value)}])}]]]
      [:div.field>div.control.is-flex.is-justify-content-center>button.button.is-link.is-rounded {:type "submit"
                                                                                                  :class (when loading "is-loading")
                                                                                                  :disabled create-disabled?
                                                                                                  :title "Click to create a new questionnaire"}
       "Create New Questionnaire"]]]))
